import { Step } from "react-joyride";
import {
  clickElement,
  jobContinueStep,
  LOOK_ONLY,
  mapSteps,
  NO_BACK,
  productSectionSteps,
  selectProductStep,
  totalsAndSendSteps,
  variantStep,
  waitFor,
  waitForSettled,
  withTourDefaults,
} from "./DraftPageTour.shared";
import { ADD_PRODUCT_STEP } from "modules/proposals/draft/draftTourContent";

const isPendingJob = () => !!document.querySelector(".tour-job-name");

const openAddProductDrawer = async () => {
  if (document.querySelector(".tour-select-product")) return;
  clickElement(".tour-add-product-button");
  await waitForSettled(".tour-select-product");
};

const showExpandedProduct = async () => {
  clickElement(".tour-add-product-drawer-close");
  if (document.querySelector(".tour-measure-job")) return;

  const header = document.querySelector<HTMLElement>(".tour-stage-header-toggle");
  if (header?.dataset.expanded === "false") {
    header.click();
    await waitFor(".tour-product-expand", 2000);
  }
  if (document.querySelector(".tour-measure-job")) return;

  clickElement(".tour-product-expand");
  await waitFor(".tour-measure-job", 2000);
};

const steps: Step[] = [
  variantStep(
    "job-name",
    isPendingJob,
    { target: ".tour-job-name", content: "Give your job a name." },
    { target: ".tour-edit-job-name", content: "Click the edit icon to change your job name." },
    {
      data: { requireValue: ".tour-job-name input" },
      ...NO_BACK,
    }
  ),
  variantStep(
    "job-address",
    isPendingJob,
    {
      target: ".tour-job-address",
      content: "Click here to open Maps and add an address to your Stage.",
    },
    {
      target: ".tour-edit-job-address",
      content: "Click the edit icon to open Maps and change the address of your Stage.",
    },
    LOOK_ONLY
  ),
  { ...jobContinueStep, targetWaitTimeout: 1000 },
  { ...selectProductStep, before: openAddProductDrawer },
  {
    id: "add-product",
    ...ADD_PRODUCT_STEP,
    ...LOOK_ONLY,
  },
  ...productSectionSteps({ before: showExpandedProduct, targetWaitTimeout: 3000 }),
  ...totalsAndSendSteps,
];

const proposalsDraftPageTourSteps: Step[] = withTourDefaults(steps);

export default proposalsDraftPageTourSteps;
